import { type Enum } from '@webapp/infrastructure/types/Enum'

// ALL-PrimaryCategories mode action selector (Feature-Set-local UI state)
export const ReportAccessSubmitActions = {
  ADD: 'add', // Bulk grant across all PrimaryCategories
  REMOVE: 'remove', // Bulk revoke across all PrimaryCategories (danger, confirmed)
} as const

export type ReportAccessSubmitActionEnum = Enum<
  typeof ReportAccessSubmitActions
>
